import { Path } from "react-hook-form";

const safePropertyMap = <T>() => {
  return (prop: Path<T>) => prop;
};

export default safePropertyMap;
